import { Component, Input, OnInit, SimpleChanges, OnChanges, Inject, ViewChild, Output, EventEmitter, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { first, takeUntil } from 'rxjs/operators';
import { Task } from '@app/_components/task';
import { TaskService } from '@app/_components/task';
import { AlertService, AuthenticationService } from '@app/_services';
import { Router } from '@angular/router';
import { SelectItem, LazyLoadEvent, MessageService, TreeNode } from 'primeng/api';
import { Subscription, Subject } from 'rxjs';
import { User, ApiResponse } from '@app/_models';
import { UserService } from '@app/_services';
import { TaskTypeEnum, NextActionEnum } from '@app/_helpers';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TaskComponent } from '@app/_components/task/task/task.component';
import { TagJoinService } from '@app/_components/_helpers/tag-join/tag-join.service';
import { Inbox } from '@app/_components/inbox';
import { InboxComponent } from '@app/_components/inbox/inbox/inbox.component';
import * as moment from 'moment';
import {DatePipe, Location} from '@angular/common';
import { ImportExportComponent } from '@app/_components/_helpers/import-export/import-export.component';
import {QuickTaskComponent} from '@app/_components/task/quick-task/quick-task.component';

@Component({
    selector: 'app-task-list',
    templateUrl: './task-list.component.html',
    styleUrls: ['./task-list.component.css'],
    standalone: false
})
export class TaskListComponent implements OnInit, OnChanges, OnDestroy {

  @Input() taskTag: any;
  private taskSummary: any = {};
  private priorityButtons: SelectItem[];
  private selectedPriority: number;
  private taskSummarySubscription: Subscription;
  
  // Configuration for task summary items
  taskSummaryConfig: any[] = [
    { label: 'Assigned to me', param: 'me', property: 'taskForUser' },
    { label: 'Due for Today', param: 'today', property: 'taskToday' },
    { label: 'Due for this week', param: 'week', property: 'taskThisWeek' },
    { label: 'Due for this Month', param: 'month', property: 'taskThisMonth' },
    { label: 'Follow up by me', param: 'me', property: 'taskForUser' },
    { label: 'Follow up Today', param: 'followuptoday', property: 'taskFollowupToday' },
    { label: 'Follow up this week', param: 'followupweek', property: 'taskFollowupThisWeek' },
    { label: 'Follow up Month', param: 'followupmonth', property: 'taskFollowupThisMonth' }
  ];
  
  getTaskSummaryItems(): any[] {
    return this.taskSummaryConfig.map(item => ({
      ...item,
      value: this.taskSummary?.[item.property] || 0
    }));
  }
  @ViewChild(ImportExportComponent) importExportComponent: ImportExportComponent;
  @ViewChild('pt') pt: any;
  statuses: any;
  priorities: any;
  loadTaskForMailId: any;
  loadStatusEnabled = false;
  usersSearch: any[];
  showOpenSummary = false;
  taskApiData: any;
  readonly moment = moment;

  visible: boolean = false;
  statusUpdateRange: Date[] | undefined;
  statusUpdateRangeStr: any[] | undefined;
  get taskTypeEnum() { return TaskTypeEnum; }
  get nextActionEnum() { return NextActionEnum; }

  currentUser: User;
  currentUserSubscription: Subscription;

  // list
  datasource: Task[];
  task: Task;
  tasks: Task[] = [];
  taskList: any[] = [];
  recordTotal: number;
  lazyLoadEvent: LazyLoadEvent;
  loading = true;
  multiSortMeta = [];

  @Input() showFilter = true;
  @Input() showPagination = true;
  @Input() outlineNewButton = true;
  @Input() loadChild = false;
  @Input() inputTask: any;
  @Input() groupBy: string = 'none';
  @Input() columns: any[] = [];
  @Input() viewControlsFilters: any = {}; // Filters from task-view-controls

  // Entity-embedded mode: locks the list to a specific taskSource / taskSourceId.
  // When provided, these filters are applied before every loadLazy call and
  // cannot be overridden by the user.  Used when embedding the task list on
  // Quote, OwnerLead, Reservation, OwnerStatement, and other entity pages.
  @Input() lockedFilters: { taskSource?: number; taskSourceId?: number } | null = null;
  @Input() defaultAssignee: number | null = null;
  @Input() showCreateButton = false;
  @Input() title: string | null = null;
  @Output() tasksLoaded = new EventEmitter<Task[]>();
  @Output() filtersChanged = new EventEmitter<any>(); // Emit filter changes to parent

  defaultColumns: any[] = [
    { field: 'dateDue', header: 'Due Date', width: '10%', visible: true },
    { field: 'name', header: 'Name', width: '20%', visible: true },
    { field: 'assignedToUserVO.lastName', header: 'Assigned To', width: '10%', visible: true },
    { field: 'priority', header: 'Priority', width: '15%', visible: true },
    { field: 'createdByUserVO.lastName', header: 'Author', width: '10%', visible: true },
    { field: 'requestedByUserVO.lastName', header: 'RequestedBy', width: '10%', visible: true },
    { field: 'status', header: 'Status', width: '15%', visible: true },
    { field: 'dateToFollowup', header: 'Followup Date', width: '12%', visible: true },
    { field: 'dateCreated', header: 'Created', width: '10%', visible: true },
    { field: 'dateCompleted', header: 'Completed', width: '12%', visible: true },
  ];

  // Grouped tasks
  groupedTasks: Map<string, Task[]> = new Map();
  groupKeys: string[] = [];
  showGrouping = false;

  assignedSearchToUser: any;
  createdBySearchToUser: any;
  requestedBySearchToUser: any;
  selectedStatusFilter = [];
  selectedPriorityFilter = [];
  selectedFilterName = '';
  selectedFilterTagSearch = '';
  selectedFilterCategory = '';
  activefilter: any[] = [];
  activefilterstr: any[] = [];
  formLoading = false;
  selectedNode: TreeNode;
  items: any[];
  taskTagSelected = '';
  filters: any;
  
  // Subscription management
  private destroy$ = new Subject<void>();
  private currentLoadSubscription: Subscription | null = null;
  private isDestroying = false; // Flag to prevent new requests during destruction

  tableData: any[] = [];
  displayColumns: any[] = [];

  activeFilterMap: any = {
    'createdByUserVO.userId': 'Author',
    'assignedToUserVO.userId': 'Assigned To',
    'requestedByUserVO.userId': 'Requested By',
    'status': 'status',
    'name': 'name',
    'taskId': 'Category/tags',
    'tagList': 'Category',
    'priority': 'priority',
    'loadstatus': 'Include Status Report',
    'parentTaskId': 'Parent Task'
  };

  loadingSummary = false;

  constructor(
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private taskService: TaskService,
    private tagJoinService: TagJoinService,
    private alertService: AlertService,
    private router: Router,
    private messageService: MessageService,
    private dialog: MatDialog,
    private location: Location,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.statuses = taskService.statuses;
    this.priorities = taskService.priorities;
    this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
      this.currentUser = user;
      this.assignedSearchToUser = user;
      this.priorityButtons = [];
    });
    if (data) {
      this.showFilter = data?.showFilter;
      this.showPagination = data?.showPagination;
      this.outlineNewButton = data?.outlineNewButton;
      this.loadTaskForMailId = data?.parentMsgId;
    }
    this.filters = {};
  }

  ngOnInit() {
    // Initialize columns if not provided - use a copy to avoid reference issues
    if (!this.columns || this.columns.length === 0) {
      this.columns = this.defaultColumns.map(col => ({ ...col }));
    } else {
      // Merge incoming columns with defaults
      this.columns = this.mergeColumns(this.columns);
    }
    this.refreshSummaryCounts();
    this.findUsersWith('');
    // Ensure loading is false initially (will be set to true when loadLazy is called)
    this.loading = false;
    this.items = [
      {
        label: 'Copy Task',
        icon: 'pi pi-fw pi-copy',
        command: (event) => this.openTaskForClone()
      },
      {
        label: 'Sub Task',
        icon: 'pi pi-fw pi-clone',
        command: (event) => this.openTaskForSubTask()
      },
      {
        label: 'Mail Task',
        icon: 'pi pi-fw pi-envelope',
        command: (event) => this.openMailTask()
      },
      {
        label: 'Summary',
        icon: 'pi pi-fw pi-search',
        command: (event) => this.openSummary()
      },
      {
        label: 'Status Update req',
        icon: 'pi pi-question',
        command: (event) => this.sendStatusUpdateReq(this.selectedNode.data)
      },
      /*{
        separator: true
      },*/
    ];

    this.displayColumns = this.getDisplayColumns();
    this.updateTableData();
  }


  updateTableData() {
    this.tableData = this.showGrouping
      ? this.buildGroupedTaskList()
      : this.taskList;
  }

  buildGroupedTaskList() {
    return this.getGroupedTaskList();
  }

  private refreshSummaryCounts() {
    this.taskSummarySubscription = this.taskService.currentTaskSummary.subscribe(taskSumaary => {
      this.taskSummary = taskSumaary;
      let prtCnt = [0, 0, 0, 0, 0, 0];
      for (let i = 0; i < this.taskSummary.priorityCount?.length; i++) {
        prtCnt[this.taskSummary?.priorityCount[i]?.priority] = this.taskSummary?.priorityCount[i]?.count;
      }
      this.priorityButtons = [];
      this.priorityButtons.push({ value: 1, label: 'Critical(' + prtCnt[1] + ')', icon: 'fa fa-search', styleClass: 'p-button-danger' });
      this.priorityButtons.push({ value: 2, label: 'Immediate (' + prtCnt[2] + ')', styleClass: 'p-button-warning' });
      this.priorityButtons.push({ value: 3, label: 'Important (' + prtCnt[3] + ')', styleClass: 'p-button-success' });
      this.priorityButtons.push({ value: 4, label: 'Standard (' + prtCnt[4] + ')', styleClass: 'p-button-info' });
      this.priorityButtons.push({ value: 5, label: 'Low (' + prtCnt[5] + ')', styleClass: 'p-button-primary' });
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let propertyName in changes) {
      if (propertyName && propertyName === 'taskTag') {
        console.log('changes!!!! ' + propertyName + ' ' + JSON.stringify(changes));
        console.log('changes22222!!!! ' + JSON.stringify(this.taskTag));
        this.loadLazy(this.lazyLoadEvent);
      } else if (propertyName === 'lockedFilters') {
        if (this.lazyLoadEvent) {
          this.loadLazy(this.lazyLoadEvent);
        }
      } else if (propertyName === 'groupBy') {
        // When groupBy changes, reload tasks to apply grouping
        if (this.lazyLoadEvent) {
          this.applyGrouping();
          // If tasks are already loaded, re-apply grouping
          if (this.tasks && this.tasks.length > 0) {
            this.applyGrouping();
          }
        }
      } else if (propertyName === 'columns') {
        // Update columns when they change
        if (this.columns && this.columns.length > 0) {
          // Merge with defaults to ensure all fields are present
          const merged = this.mergeColumns([...this.columns]);
          this.columns = merged;
        } else {
          // If columns are cleared, use defaults
          this.columns = this.defaultColumns.map(col => ({ ...col }));
        }
        // Force change detection by updating the columns array reference
        this.columns = [...this.columns];
      } else if (propertyName === 'viewControlsFilters') {
        // Apply filters from task-view-controls
        this.applyViewControlsFilters();
      }
    }
  }
  
  applyViewControlsFilters() {
    if (!this.lazyLoadEvent) {
      this.lazyLoadEvent = { first: 0, rows: 25 };
    }
    if (!this.lazyLoadEvent.filters) {
      this.lazyLoadEvent.filters = {};
    }
    
    // Map filters from task-view-controls to treeTable filter format
    if (this.viewControlsFilters.name) {
      this.lazyLoadEvent.filters['name'] = {
        value: this.viewControlsFilters.name,
        matchMode: 'contains'
      };
    } else {
      delete this.lazyLoadEvent.filters['name'];
    }
    
    if (this.viewControlsFilters.status && Array.isArray(this.viewControlsFilters.status) && this.viewControlsFilters.status.length > 0) {
      this.lazyLoadEvent.filters['status'] = {
        value: this.viewControlsFilters.status,
        matchMode: 'in'
      };
      this.selectedStatusFilter = this.viewControlsFilters.status;
    } else if (!this.viewControlsFilters.status || (Array.isArray(this.viewControlsFilters.status) && this.viewControlsFilters.status.length === 0)) {
      delete this.lazyLoadEvent.filters['status'];
      this.selectedStatusFilter = [];
    }
    
    if (this.viewControlsFilters.priority && Array.isArray(this.viewControlsFilters.priority) && this.viewControlsFilters.priority.length > 0) {
      this.lazyLoadEvent.filters['priority'] = {
        value: this.viewControlsFilters.priority,
        matchMode: 'in'
      };
      this.selectedPriorityFilter = this.viewControlsFilters.priority;
    } else if (!this.viewControlsFilters.priority || (Array.isArray(this.viewControlsFilters.priority) && this.viewControlsFilters.priority.length === 0)) {
      delete this.lazyLoadEvent.filters['priority'];
      this.selectedPriorityFilter = [];
    }
    
    if (this.viewControlsFilters.assignedTo && this.viewControlsFilters.assignedTo.userId) {
      this.lazyLoadEvent.filters['assignedToUserVO.userId'] = {
        value: [this.viewControlsFilters.assignedTo.userId],
        matchMode: 'in'
      };
      this.assignedSearchToUser = this.viewControlsFilters.assignedTo;
    } else if (!this.viewControlsFilters.assignedTo) {
      delete this.lazyLoadEvent.filters['assignedToUserVO.userId'];
      this.assignedSearchToUser = null;
    }
    
    if (this.viewControlsFilters.createdBy && this.viewControlsFilters.createdBy.userId) {
      this.lazyLoadEvent.filters['createdByUserVO.userId'] = {
        value: [this.viewControlsFilters.createdBy.userId],
        matchMode: 'in'
      };
      this.createdBySearchToUser = this.viewControlsFilters.createdBy;
    } else if (!this.viewControlsFilters.createdBy) {
      delete this.lazyLoadEvent.filters['createdByUserVO.userId'];
      this.createdBySearchToUser = null;
    }
    
    if (this.viewControlsFilters.requestedBy && this.viewControlsFilters.requestedBy.userId) {
      this.lazyLoadEvent.filters['requestedByUserVO.userId'] = {
        value: [this.viewControlsFilters.requestedBy.userId],
        matchMode: 'in'
      };
      this.requestedBySearchToUser = this.viewControlsFilters.requestedBy;
    } else if (!this.viewControlsFilters.requestedBy) {
      delete this.lazyLoadEvent.filters['requestedByUserVO.userId'];
      this.requestedBySearchToUser = null;
    }
    
    // Date range filters
    if (this.viewControlsFilters.dateDue && Array.isArray(this.viewControlsFilters.dateDue) && this.viewControlsFilters.dateDue.length === 2) {
      // Convert to filter format - this might need adjustment based on your API
      // For now, we'll apply it in the loadLazy method
    }
    console.log('viewControlsFilters.parentTaskId: ' ,this.viewControlsFilters);
    // Parent Task ID filter (for subtasks)
    if (this.viewControlsFilters.parentTaskId) {
      this.lazyLoadEvent.filters['parentTaskId'] = {
        value: this.viewControlsFilters.parentTaskId,
        matchMode: 'in'
      };
    } else if (this.viewControlsFilters.hasOwnProperty('parentTaskId') && !this.viewControlsFilters.parentTaskId) {
      delete this.lazyLoadEvent.filters['parentTaskId'];
    }
    
    // Reload data with new filters
    if (this.lazyLoadEvent) {
      this.loadLazy(this.lazyLoadEvent);
    }
  }

  mergeColumns(newColumns: any[]): any[] {
    if (!newColumns || newColumns.length === 0) {
      return this.defaultColumns.map(col => ({ ...col }));
    }
    
    // Create a map of new columns by field
    const columnMap = new Map();
    newColumns.forEach(col => {
      columnMap.set(col.field, col);
    });
    
    // Merge with defaults, keeping new column settings (especially visible property)
    return this.defaultColumns.map(defaultCol => {
      const newCol = columnMap.get(defaultCol.field);
      if (newCol) {
        // Merge, newCol takes precedence, especially for visible property
        return { 
          ...defaultCol, 
          ...newCol, 
          visible: newCol.visible !== undefined ? newCol.visible : (defaultCol.visible !== undefined ? defaultCol.visible : true)
        };
      }
      return { ...defaultCol };
    });
  }

  getFilteredTags(tags, selectedTag) {
    // if filter text input is empty then load all records
    if (!selectedTag) {
      this.taskTag = null;
    }
    if (tags == '0') {
      delete this.lazyLoadEvent.filters.taskId;
      this.loadLazy(this.lazyLoadEvent);
    } else {
      // If records found then show filtered records
      if (tags.length > 0) {
        // if filter text input is not empty then load filtered records only
        let retrivedTasks = [];
        tags.forEach(tag => {
          retrivedTasks.push(tag.tagSourceId);
        });
        this.lazyLoadEvent.filters.taskId = { 'value': retrivedTasks, 'matchMode': 'in' };
        this.loadLazy(this.lazyLoadEvent);
      } else {
        // Display empty table as no record found with filtered input
        this.tasks = [];
        this.taskList = [];
        this.recordTotal = 0;
        this.updateTableData();
      }
    }
  }

  addFilterTag(event) {
    console.log('addFilterTag!!!! ' + JSON.stringify(event));
  }

  deleteFilterTag(event) {
    console.log('deleteFilterTag!!!! ' + JSON.stringify(event));
  }



  addUser(): void {
    this.router.navigate(['user-add']);
  }

  loadLazy(event: LazyLoadEvent) {
    // Don't make new requests if component is being destroyed
    if (this.isDestroying) {
      console.log('Component is being destroyed, skipping API call...');
      return;
    }
    
    // Prevent multiple simultaneous API calls
    if (this.loading && this.currentLoadSubscription) {
      console.log('API call already in progress, skipping...');
      return;
    }
    
    if (event != undefined && this.loadTaskForMailId && this.loadTaskForMailId > 0) {
      event.filters = {};
      event.filters['msgVO.msgId'] = {};
      event.filters['msgVO.msgId'].value = this.loadTaskForMailId;
      event.filters['msgVO.msgId'].matchMode = 'in';
    }
    else {
      // Ensure filters object exists
      if (event != undefined && !event.filters) {
        event.filters = {};
      }

      // Apply parentTaskId filter from viewControlsFilters (for subtasks)
      if (event != undefined && this.viewControlsFilters && this.viewControlsFilters.parentTaskId) {
        event.filters['parentTaskId'] = {
          value: this.viewControlsFilters.parentTaskId,
          matchMode: 'in'
        };
      }

      if (event != undefined && event.filters['status']) {
        event.filters['status'].value = this.selectedStatusFilter;
      }
    }

    // Apply locked entity filters (taskSource / taskSourceId) when the list
    // is embedded on a specific entity page.  These are set after all other
    // filter logic so they cannot be overwritten by user-driven filter changes.
    if (event != undefined && this.lockedFilters) {
      if (this.lockedFilters.taskSource != null) {
        event.filters['taskSource'] = { value: this.lockedFilters.taskSource, matchMode: 'in' };
      }
      if (this.lockedFilters.taskSourceId != null) {
        event.filters['taskSourceId'] = { value: this.lockedFilters.taskSourceId, matchMode: 'in' };
      }
    }
    if (event != undefined && event.filters['priority']) {
      event.filters['priority'].value = this.selectedPriorityFilter;
    }
    if (event != undefined && this.assignedSearchToUser) {
      event.filters['assignedToUserVO.userId'] = {};
      event.filters['assignedToUserVO.userId'].matchMode = 'in';
      event.filters['assignedToUserVO.userId'].value = this.assignedSearchToUser?.userId;
    }

    // default sort
    if (event != undefined && event && !event.multiSortMeta) {
      event.multiSortMeta = [];
      event.multiSortMeta.push({ field: 'dateCreated', order: -1 });
      event.multiSortMeta.push({ field: 'dateDue', order: -1 });
    }
    if (event != undefined && this.selectedPriority) {
      event.filters.priority = { 'value': this.selectedPriority, 'matchMode': 'in' };
    }
    if (event != undefined && this.loadStatusEnabled) {
      event.filters.loadstatus = { 'value': this.loadStatusEnabled, 'matchMode': 'in' };
    }
    else {
      if (event != undefined) {
        delete event.filters.loadstatus;
      }

    }

    this.activefilter = [];
    if (event != undefined) {
      for (let prop in event.filters) {
        let dispayName: string = '<strong>' + this.activeFilterMap[prop] + ':</strong> ' + event.filters[prop].value;
        switch (prop) {
          case 'taskId':
            dispayName = this.taskTag ? '<strong>Category:</strong> ' + this.taskTag?.name : '<strong>Tags</strong>';
            break;
          case 'status':
            dispayName = '<strong>Status:</strong> ';
            let selectedStatus = event.filters[prop]?.value;
            if (Array.isArray(selectedStatus) && selectedStatus.length > 0) {
              let statusNames = selectedStatus.map((statusId: number) => {
                return this.statuses[statusId]?.name;
              }).filter((name: string) => name).join(', ');
              dispayName = '<strong>Status:</strong> ' + statusNames;
            }
            break;
          case 'assignedToUserVO.userId':
            let assignedToValue = event.filters[prop]?.value;
            if (Array.isArray(assignedToValue) && assignedToValue.length > 0) {
              let userNames = assignedToValue.map((userId: number) => {
                let user = this.usersSearch?.find((u: any) => u.userId === userId);
                return user ? this.fullName(user) : null;
              }).filter((name: string) => name).join(', ');
              dispayName = '<strong>Assigned To:</strong> ' + userNames;
            } else if (this.assignedSearchToUser) {
              dispayName = '<strong>Assigned To:</strong> ' + this.fullName(this.assignedSearchToUser);
            } else if (assignedToValue && (typeof assignedToValue === 'number' || (typeof assignedToValue === 'string' && !isNaN(Number(assignedToValue))))) {
              // Handle single userId value (from table click)
              let userId = typeof assignedToValue === 'number' ? assignedToValue : Number(assignedToValue);
              let user = this.usersSearch?.find((u: any) => u.userId === userId);
              if (user) {
                dispayName = '<strong>Assigned To:</strong> ' + this.fullName(user);
              }
            }
            break;
          case 'createdByUserVO.userId':
            let createdByValue = event.filters[prop]?.value;
            if (Array.isArray(createdByValue) && createdByValue.length > 0) {
              let userNames = createdByValue.map((userId: number) => {
                let user = this.usersSearch?.find((u: any) => u.userId === userId);
                return user ? this.fullName(user) : null;
              }).filter((name: string) => name).join(', ');
              dispayName = '<strong>Author:</strong> ' + userNames;
            } else if (this.createdBySearchToUser) {
              dispayName = '<strong>Author:</strong> ' + this.fullName(this.createdBySearchToUser);
            } else if (createdByValue && (typeof createdByValue === 'number' || (typeof createdByValue === 'string' && !isNaN(Number(createdByValue))))) {
              // Handle single userId value (from table click)
              let userId = typeof createdByValue === 'number' ? createdByValue : Number(createdByValue);
              let user = this.usersSearch?.find((u: any) => u.userId === userId);
              if (user) {
                dispayName = '<strong>Author:</strong> ' + this.fullName(user);
              }
            }
            break;
          case 'requestedByUserVO.userId':
            let requestedByValue = event.filters[prop]?.value;
            if (Array.isArray(requestedByValue) && requestedByValue.length > 0) {
              let userNames = requestedByValue.map((userId: number) => {
                let user = this.usersSearch?.find((u: any) => u.userId === userId);
                return user ? this.fullName(user) : null;
              }).filter((name: string) => name).join(', ');
              dispayName = '<strong>Requested By:</strong> ' + userNames;
            } else if (this.requestedBySearchToUser) {
              dispayName = '<strong>Requested By:</strong> ' + this.fullName(this.requestedBySearchToUser);
            } else if (requestedByValue && (typeof requestedByValue === 'number' || (typeof requestedByValue === 'string' && !isNaN(Number(requestedByValue))))) {
              // Handle single userId value (from table click)
              let userId = typeof requestedByValue === 'number' ? requestedByValue : Number(requestedByValue);
              let user = this.usersSearch?.find((u: any) => u.userId === userId);
              if (user) {
                dispayName = '<strong>Requested By:</strong> ' + this.fullName(user);
              }
            }
            break;
          case 'priority':
            dispayName = '<strong>Priority:</strong> ';
            let selectedPriority = event.filters[prop]?.value;
            if (Array.isArray(selectedPriority) && selectedPriority.length > 0) {
              let priorityNames = selectedPriority.map((priorityId: number) => {
                let priorityObj = this.priorities.find((p: any) => p.value === priorityId);
                return priorityObj?.name;
              }).filter((name: string) => name).join(', ');
              dispayName = '<strong>Priority:</strong> ' + priorityNames;
            } else if (selectedPriority) {
              let priorityObj = this.priorities.find((p: any) => p.value === selectedPriority);
              if (priorityObj) {
                dispayName = '<strong>Priority:</strong> ' + priorityObj.name;
              }
            }
            break;
          case 'parentTaskId':
            dispayName = '<strong>Parent Task:</strong> ' + event.filters[prop]?.value;
            break;
        }
        let entry: any = { 'name': prop, 'displayName': dispayName, 'value': event.filters[prop] };
        this.activefilter.push(entry);
      }
    }

    if (event && event.filters) {
      const flatFilters: any = {};
      for (const key of Object.keys(event.filters)) {
        const f: any = event.filters[key];
        flatFilters[key] = (f && typeof f === 'object' && 'value' in f) ? f.value : f;
      }
      this.filtersChanged.emit(flatFilters);
    }
    try {
      this.loading = true;
      this.lazyLoadEvent = event;

      console.log(
        ' event.first:' + event.first
        + '  |  event.rows:' + event.rows
        + '  |  event.sortField:' + event.sortField
        + '  |  event.sortOrder:' + event.sortOrder
        + '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
        + '  |  event.globalFilter:' + event.globalFilter
        + '  |  event.filters:' + JSON.stringify(event.filters)
      );

      const pageNumber = Math.round(event.first / event.rows);
      if (this.statusUpdateRange) {
        this.statusUpdateRangeStr = [];
        this.statusUpdateRangeStr.push(this.datePipe.transform(this.statusUpdateRange[0], 'yyyy-MM-ddThh:mm'));
        if (this.statusUpdateRange[1]) {
          this.statusUpdateRangeStr.push(this.datePipe.transform(this.statusUpdateRange[1], 'yyyy-MM-ddThh:mm'));
        }
      }
      // Cancel any existing subscription
      if (this.currentLoadSubscription) {
        this.currentLoadSubscription.unsubscribe();
        this.currentLoadSubscription = null;
      }

      this.currentLoadSubscription = this.taskService.findByFilterSummaryWithDateRange(
        pageNumber, event.rows,
        event.sortField,
        event.sortOrder,
        event.multiSortMeta,
        event.globalFilter,
        event.filters, this.statusUpdateRangeStr).pipe(
          first(),
          takeUntil(this.destroy$)
        ).subscribe(

          apiResponse => {
            try {
              // console.log('tasks are: ' + JSON.stringify(apiResponse));
              // Add null checks for response data
              if (!apiResponse || !apiResponse.data) {
                console.error('Invalid API response:', apiResponse);
                this.loading = false;
                this.currentLoadSubscription = null;
                return;
              }

              this.datasource = apiResponse.data?.users || [];
              this.recordTotal = apiResponse.page?.recordTotal || 0;
              this.tasks = apiResponse.data?.tasks || [];
              
              // Ensure recordTotal is a valid number
              if (isNaN(this.recordTotal) || this.recordTotal < 0) {
                this.recordTotal = this.tasks.length;
              }
              
              // Reset loading state IMMEDIATELY to unblock UI before processing
              this.loading = false;
              this.currentLoadSubscription = null;
              
              // Use markForCheck for better performance (triggers change detection in next cycle)
              this.cdr.markForCheck();
              
              // Process tasks asynchronously in chunks to prevent UI blocking
              this.processTasksAsync(this.tasks);
            } catch (error) {
              console.error('Error processing API response:', error);
              this.alertService.error('Error processing task data: ' + (error.message || error));
              this.loading = false;
              this.currentLoadSubscription = null;
              // Use markForCheck for better performance
              this.cdr.markForCheck();
            }
          },
          apiResponse => {
            console.log('USER LIST!: ' + JSON.stringify(apiResponse));
            this.alertService.error(apiResponse);
            this.loading = false; // CRITICAL FIX: Reset loading on error
            this.currentLoadSubscription = null;
            // Use markForCheck for better performance
            this.cdr.markForCheck();
          },
          () => { 
            this.loading = false;
            this.currentLoadSubscription = null;
            // Use markForCheck for better performance
            this.cdr.markForCheck();
          }
        );

      if (this.datasource) {
        this.tasks = this.datasource.slice(event.first, (event.first + event.rows));
      }
    } catch (error) {
      console.log('loadLazy(' + event + ')' + error);
      this.loading = false; // CRITICAL FIX: Reset loading on exception
      this.currentLoadSubscription = null;
    }
  }

  onRowSelect(event) {

    this.onOpenFormEdit(event.data);
  }

  /*********
   * Edit Button
   *
   */
  onOpenFormEdit(task: Task) {

    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.height = "100vh";
    dialogConfig.width = "100vw";
    dialogConfig.maxWidth = "100vw";
    dialogConfig.maxHeight = "100vh";
    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      task: task,
      title: '',
      taskApi: task,
      isModal: true
    };
    this.location.go('/task-view/' + task.taskId);
    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(TaskComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.location.go('/');

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        this.updateTaskCB(data);
        this.loadLazy(this.lazyLoadEvent);
        // close the dialogBox
        // dialogRef.close();
      });

    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        console.log('Dialog output:', data);

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        this.addTaskCB(data);
        this.loadLazy(this.lazyLoadEvent);
        // close the dialogBox
        dialogRef.close();
      });

    dialogRef.componentInstance.doaddAndDontClose.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.addTaskCB(data);
        this.loadLazy(this.lazyLoadEvent);

      });

    dialogRef.componentInstance.doUpdateAndDontClose.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.updateTaskCB(data);
        this.loadLazy(this.lazyLoadEvent);
      });

    dialogRef.componentInstance.doDelete.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.location.go('/');
        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        //this.deleteTestCB(data);

        // close the dialogBox
        dialogRef.close();
      });
  }
  sendStatusUpdateReq(task: Task) {
    this.formLoading = false;
    this.taskService.sendStatusUpdateReq(task)
      .pipe(first())
      .subscribe(
        res => {
          const message = typeof res === 'string' ? res : (res?.message || 'Status update request sent successfully');
          this.messageService.add({ severity: 'success', summary: 'Success', detail: message, life: 5000 });
          console.log('Task-Update SUCCESS: ' + JSON.stringify(res));
        },
        err => {
          console.log('Task-Update FAIL: ' + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        });
  }
  updateTaskCB(task: Task) {
    console.log('Updating Test: ' + JSON.stringify(task));
    let itemIndex = this.tasks.findIndex((item: any) => item.taskId === task.taskId);
    this.tasks[itemIndex] = task;

    // no idea what this is but it is required to update the array
    this.tasks = [...this.tasks];
    let node = { 'data': task, leaf: false };
    this.taskList[itemIndex] = node;
    this.taskList = [...this.taskList];
    this.updateTableData();
    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Test ' + task.taskId + ' Updated', life: 3000 });
  }

  daysFromToday(date: Date): any {
    let today = new Date();
    let dateDue = new Date(date);
    if (dateDue.valueOf() === 0) { return ''; }
    // console.log(today.valueOf());
    // console.log(dateDue.valueOf());
    return Math.ceil((dateDue.getTime() - today.getTime()) / (1000 * 3600 * 24));
  }

  daysFromTodayAbs(date: Date): any {
    if (!date) { return ''; }
    let today = new Date();
    let dateDue = new Date(date);
    if (dateDue.valueOf() === 0) { return ''; }
    return Math.abs(Math.ceil((today.getTime() - dateDue.getTime()) / (1000 * 3600 * 24)));
  }
  daysFromTodayAbsDue(date: Date): any {
    if (!date) {
      return 0;
    }
    let today = new Date();
    let dateDue = new Date(date);
    if (dateDue.valueOf() === 0) { return 0; }
    return Math.ceil((today.getTime() - dateDue.getTime()) / (1000 * 3600 * 24));
  }
  daysFromTodayAbsDueFloor(date: Date): any {
    if (!date) {
      return 0;
    }
    let today = new Date();
    let dateDue = new Date(date);
    if (dateDue.valueOf() === 0) { return 0; }
    return Math.floor((today.getTime() - dateDue.getTime()) / (1000 * 3600 * 24));
  }


  priorityColor(dueDate: Date): any {
    if (this.daysFromToday(dueDate) === 0) { return 'pink'; }
    if (this.daysFromToday(dueDate) > 0 && this.daysFromToday(dueDate) < 3) { return 'lightyellow'; }
    if (this.daysFromToday(dueDate) < 0) { return 'red'; }
    return 'transparent';
  }

  reloadPage() {
    window.location.reload();
  }
  reloadSummaryCount() {
    this.loadingSummary = true;
    this.taskService.getTaskSummary(this.currentUser.userId).pipe(first()).subscribe(dataCount => {
      this.refreshSummaryCounts();
      this.loadingSummary = false;
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Summary Counts Reloaded', life: 3000 });
    }, error => {
      this.loadingSummary = false;
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to reload summary counts', life: 3000 });
      this.alertService.error(error);
    });
  }
  loadWithParam(type: string) {
    this.loadLazyForSummary(this.lazyLoadEvent, type);
  }
  loadLazyForSummary(event: LazyLoadEvent, type: string) {
    event = this.lazyLoadEvent;
    if (event && !event.multiSortMeta) {
      event.multiSortMeta = [];
      event.multiSortMeta.push({ field: 'dateCreated', order: 0 });
    }
    // if filtering by tagId
    if (this.taskTag) {
      event.filters.tagList = { 'value': this.taskTag, 'matchMode': 'in' };
    }

    try {
      this.loading = true;
      this.lazyLoadEvent = event;

      console.log(
        ' event.first:' + event.first
        + '  |  event.rows:' + event.rows
        + '  |  event.sortField:' + event.sortField
        + '  |  event.sortOrder:' + event.sortOrder
        + '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
        + '  |  event.globalFilter:' + event.globalFilter
        + '  |  event.filters:' + JSON.stringify(event.filters)
      );

      const pageNumber = Math.round(event.first / event.rows);
      this.taskService.findByTaskListSummary(
        pageNumber, event.rows,
        event.sortField,
        event.sortOrder,
        event.multiSortMeta,
        event.globalFilter,
        event.filters, this.currentUser.userId, type).pipe(first()).subscribe(

          apiResponse => {
            // console.log('tasks are: ' + JSON.stringify(apiResponse));
            this.datasource = apiResponse.data.users;
            this.recordTotal = apiResponse.page.recordTotal;
            this.tasks = apiResponse.data.tasks;
            this.taskList = [];
            for (let i = 0; i < this.tasks.length; i++) {
              let node = {
                'data': this.tasks[i],
                leaf: false
              };
              this.taskList.push(node);
            }
            this.updateTableData();
          },
          apiResponse => {
            console.log('USER LIST!: ' + JSON.stringify(apiResponse));
            this.alertService.error(apiResponse);
            this.loading = false; // CRITICAL FIX: Reset loading on error
          },
          () => { this.loading = false; }
        );

      if (this.datasource) {
        this.tasks = this.datasource.slice(event.first, (event.first + event.rows));
      }
    } catch (error) {
      console.log('loadLazy(' + event + ')' + error);
      this.loading = false; // CRITICAL FIX: Reset loading on exception
      this.currentLoadSubscription = null;
    }
  }

  loadLazyForPriority(event: any) {
    this.selectedPriority = event.value.value;
    this.lazyLoadEvent.filters = {};
    this.loadLazy(this.lazyLoadEvent);
  }
  getStatusName(taskApi: any) {
    if (taskApi && taskApi?.status !== undefined) {
      const status = this.statuses.find((e: any) => e.value === taskApi?.status);
      return status.name;
    } else {
      return '';
    }
  }

  onOpenFormAdd() {

    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.width = '100vw';
    dialogConfig.height = '100vh';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.maxHeight = '100vh';
    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: 'Add Task',
      isModal: true
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(TaskComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        console.log('Dialog output:', data);

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        this.addTaskCB(data);
        this.loadLazy(this.lazyLoadEvent);
        // close the dialogBox
        dialogRef.close();
      });
  }
  addTaskCB(task: Task) {
    console.log('Adding Test: ' + JSON.stringify(task));
    // if we don't have a tests array yet...
    if (!this.tasks) {
      this.tasks = [];
    }
    // unshift adds to the front of the array (), push adds to the back
    this.tasks.unshift(task);

    // no idea what this is but it is required to update the array
    this.tasks = [...this.tasks];
    let node = { 'data': task, leaf: false };
    this.taskList.unshift(node);
    this.taskList = [...this.taskList];
    this.updateTableData();
    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Test ' + task.taskId + ' Added', life: 3000 });
  }

  getNumnerOfTask(task: any) {
    if (!task?.jsonChildTask) {
      return 0;
    }
    return JSON.parse(task?.jsonChildTask).length;
  }
  getNumnerOfTasks(rowData: any) {
    if (true) return rowData?.children?.length;
    let allowedChild: Task[] = [];
    for (let i = 0; i < rowData?.children?.length; i++) {
      let child = rowData?.children[i];
      allowedChild.push(child);
      //subtasks will be visible irrespective of permissions
      let statusFilter = this.lazyLoadEvent?.filters['status']?.value;

      if (statusFilter) {

      }
      if (this.currentUser.userId === child.assignedTo?.userId || this.currentUser.userId === child.createdBy?.userId ||
        this.currentUser.userId === child.ownedBy?.userId) {
        allowedChild.push(child);
        continue;
      }
    }
    return allowedChild.length;
  }
  getColorForDue(task: any) {
    let color = 'white';
    if (!task || !task?.dateDue) {
      return color;
    }
    if (this.daysFromTodayAbsDueFloor(task?.dateDue) > 0) {
      color = '#d7164d';
    }
    else if (this.daysFromTodayAbsDueFloor(task?.dateDue) < 0) {
      color = '#11a145';
    }
    else {
      color = 'blue';
    }
    return color;
  }
  addTask(tasktypeId: any) {

    const dialogConfig = new MatDialogConfig();

    // settings
    // dialogConfig.disableClose = false;
    // dialogConfig.autoFocus = true;
    // dialogConfig.hasBackdrop = true;
    // dialogConfig.width = '1000px';
    // dialogConfig.height = '80vh';
    // dialogConfig.maxWidth = '1000px';
    // dialogConfig.maxHeight = '80vh';

    dialogConfig.width = '100vw';
    dialogConfig.height = '100vh';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.maxHeight = '100vh';

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: 'Add Task',
      taskTypeId: tasktypeId,
      isModal: true,
      // Pre-seed entity link when embedded on a specific entity page
      taskSource: this.lockedFilters?.taskSource ?? null,
      taskSourceId: this.lockedFilters?.taskSourceId ?? null,
      assignedToUserId: this.defaultAssignee ?? null
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(TaskComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        console.log('Dialog output:', data);

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        this.addTaskCB(data);
        this.loadLazy(this.lazyLoadEvent);
      });
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.loadLazy(this.lazyLoadEvent);
      });
    dialogRef.componentInstance.doUpdateAndDontClose.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.loadLazy(this.lazyLoadEvent);
      });
  }
  addQuickTask(tasktypeId: any) {

    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.width = '100%';
    dialogConfig.height = '100%';
    dialogConfig.maxWidth = '1600px';
    dialogConfig.maxHeight = '800px';
    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: 'Add Task',
      taskTypeId: tasktypeId,
      isModal: true
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(QuickTaskComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        console.log('Dialog output:', data);

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        this.addTaskCB(data);
        this.loadLazy(this.lazyLoadEvent);
        dialogRef.close();
      });
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.loadLazy(this.lazyLoadEvent);
      });
  }
  onNodeExpand(event: any) {
    const node = event.node;
    let subtaskList = [];
    let tasks = node?.data?.children;
    for (let i = 0; i < tasks.length; i++) {
      /* if ( this.currentUser.userId === tasks[i]?.assignedTo?.userId || this.currentUser.userId === tasks[i]?.createdBy?.userId ||
         this.currentUser.userId === tasks[i]?.ownedBy?.userId ) */
      tasks[i].ischild = true;
      let entry = {
        'data': tasks[i],
        leaf: false,
      };
      subtaskList.push(entry);

    }
    node.children = subtaskList;
    this.taskList = [...this.taskList];
    this.updateTableData();
  }

  // keeping older node expand for reference
  onNodeExpand1(event: any) {
    const node = event.node;
    const childTask = [];
    let lazyLoadEvent1: LazyLoadEvent = this.lazyLoadEvent;
    lazyLoadEvent1.filters = {};
    lazyLoadEvent1.filters['parentTaskId'] = {};
    lazyLoadEvent1.filters['parentTaskId'].value = node?.data?.taskId;
    lazyLoadEvent1.filters['parentTaskId'].matchMode = 'in';
    this.taskService.findByFilterSummary(
      0, 200,
      lazyLoadEvent1.sortField,
      lazyLoadEvent1.sortOrder,
      lazyLoadEvent1.multiSortMeta,
      lazyLoadEvent1.globalFilter,
      lazyLoadEvent1.filters).pipe(first()).subscribe(

        apiResponse => {
          // console.log('tasks are: ' + JSON.stringify(apiResponse));
          this.datasource = apiResponse.data.users;
          this.recordTotal = apiResponse.page.recordTotal;
          this.tasks = apiResponse.data.tasks;
          let subtaskList = [];
          for (let i = 0; i < this.tasks.length; i++) {
            this.tasks[i].ischild = true;
            let entry = {
              'data': this.tasks[i],
              leaf: false,
            };
            subtaskList.push(entry);
          }
          node.children = subtaskList;
          this.taskList = [...this.taskList];
          this.updateTableData();
        },
        apiResponse => {
          console.log('USER LIST!: ' + JSON.stringify(apiResponse));
          this.alertService.error(apiResponse);
        },
        () => { this.loading = false; }
      );
  }
  findUsersWith(queryString: string) {
    this.userService.findUsersWith(queryString).pipe(first()).subscribe(

      data => {
        console.log('taskUser serach: ' + JSON.stringify(data));
        this.usersSearch = [];
        this.usersSearch = data.data.userSummaryList;
        this.usersSearch.forEach(user => {
          if (!user.lastName) { user.lastName = ''; }
          if (!user.firstName) { user.firstName = ''; }
          user.fullName = user.firstName + ' ' + user.lastName;
        });
        // console.log('QA: ' + JSON.stringify(this.taskUserSuggestions));
      },
      error => {
        // console.log('reports LIST!: ' + JSON.stringify(error));
        this.alertService.error(error);
      },
      () => { }
    );
  }

  onTagSelect(event: any) {
    this.taskTag = event;

    if (this.taskTag) {
      this.tagJoinService.findTagsWithType(this.taskTag?.name, 40, this.taskTag?.tagType).pipe(first()).subscribe(
        res => {
          console.log(res.data.tagJoin);
          this.getFilteredTags(res.data.tagJoin, this.taskTag);
        },
        error => {
          // console.log('reports LIST!: ' + JSON.stringify(error));
          this.alertService.error(error);
        },
        () => { }
      );
    } else {
      this.getFilteredTags('0', this.taskTag);
    }
  }
  openCm(event, cm, rowNode) {
    event.preventDefault();
    event.stopPropagation();
    cm.show(event);
    this.selectedNode = rowNode?.node;
    return false;
  }
  openSummary() {
    this.taskApiData = this.selectedNode.data;
    this.showOpenSummary = true;
  }
  openMailTask() {
    let taskApi = this.selectedNode.data;
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    let inbox = new Inbox();
    inbox.subject = taskApi.name;
    inbox.senderEmail = taskApi?.assignedTo?.emailAddress;
    inbox.emailHtml = this.getTaskMailContent(taskApi);
    inbox.emailText = this.getTaskMailContent(taskApi);
    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      inbox: inbox,
      title: 'Mail Task Details',
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(InboxComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Mail Sent', life: 5000 });
        console.log('Dialog output:', data);
        dialogRef.close();
      });
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Mail Sent', life: 5000 });
        console.log('Dialog output:', data);
        dialogRef.close();
      });
  }
  getTaskMailContent(taskApi: any) {
    let taskLink = 'https://admin.kbmhawaii.com/task-view/' + taskApi?.taskId;
    let emailHTML = '<h4>Hi, Please find task details</h4> <br><br><table>' +
      '<tr><th colspan="1">Task assigned</th><th colspan="5"><a href="' + taskLink + '" targrt="_blank">Click here to view task</a></th></tr>' +
      '<tr><td>Task Name</td><td> ' + this.makeSafe(taskApi.name) + '</td></tr>' +
      '<tr><td>Due Date</td><td> ' + this.makeSafe(taskApi.dateDue) + '</td></tr>' +
      '<tr><td>Created By</td><td> ' + this.makeSafe(taskApi?.createdBy?.lastName) + ' , ' + this.makeSafe(taskApi?.createdBy?.firstName) + '</td></tr>' +
      '<tr><td>Owned By</td><td> ' + this.makeSafe(taskApi?.ownedBy?.lastName) + ' , ' + this.makeSafe(taskApi?.ownedBy?.firstName) + '</td></tr>' +
      '<tr><td>Due Date</td><td> ' + this.makeSafe(taskApi.dateDue) + '</td></tr>' +
      '<tr><td>Status</td><td> ' + this.getStatusName(taskApi) + '</td></tr>' +
      '<tr><td>Doc</td><td> ' + this.makeSafe(taskApi?.miniDoc) + '</td></tr>' +
      '</table>';
    return emailHTML;
  }
  makeSafe(val: any) {
    return val ? val : '';
  }
  openTaskForClone() {
    let task = this.selectedNode.data;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.width = '100vw';
    dialogConfig.height = '100vh';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.maxHeight = '100vh';
    // pass data, ie rateBuicket: this.shortTermRentalId,
    let passingTask: any = new Task();
    Object.assign(passingTask, task);
    passingTask.jsonChildTask = null;
    passingTask.taskId = null;
    passingTask.miniDoc = null;
    dialogConfig.data = {
      title: 'Copy Task',
      isModal: true,
      taskApi: passingTask,
      purpose: 'clone',
      copyfromtaskid: task.taskId
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(TaskComponent, dialogConfig);

    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.loadLazy(this.lazyLoadEvent);
      });
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.loadLazy(this.lazyLoadEvent);
      });
    dialogRef.componentInstance.doaddAndDontClose.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.loadLazy(this.lazyLoadEvent);
      });

  }
  openTaskForSubTask() {
    let task = this.selectedNode.data;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.width = '100vw';
    dialogConfig.height = '100vh';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.maxHeight = '100vh';
    // pass data, ie rateBuicket: this.shortTermRentalId,
    let passingTask: any = new Task();
    Object.assign(passingTask, task);
    passingTask.name = '';
    passingTask.taskId = null;
    passingTask.parentTaskId = task?.taskId;
    passingTask.msgId = task.msgId;
    passingTask.jsonChildTask = null;
    passingTask.miniDoc = null;
    dialogConfig.data = {
      title: 'Assign Task',
      isModal: true,
      taskApi: passingTask,
      purpose: 'clone',
      copyfromtaskid: task?.taskId
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(TaskComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.loadLazy(this.lazyLoadEvent);
      });
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.loadLazy(this.lazyLoadEvent);
      });
    dialogRef.componentInstance.doaddAndDontClose.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.loadLazy(this.lazyLoadEvent);
      });

  }
  fullName(user: any) {
    let fullName = '';
    if (user?.firstName) {
      fullName = fullName + user?.firstName + ' ';
    }
    if (user?.lastName) {
      fullName = fullName + user?.lastName;
    }
    return fullName;
  }
  changeInplaceData(event, taskApi) {
    let updatedStatus = event?.value;
    let newEvent: any = {};
    taskApi.status = updatedStatus;
    newEvent.data = taskApi;
    newEvent.field = 'status';
    this.onCellEditComplete(newEvent);
  }
  changeInplaceDataPriority(event, taskApi) {
    let priority = event?.value;
    let newEvent: any = {};
    taskApi.priority = priority;
    newEvent.data = taskApi;
    newEvent.field = 'priority';
    this.onCellEditComplete(newEvent);
  }
  onCellEditInit(event: any): void { }
  onCellEditComplete(event: any): void {
    let rowData = event.data;
    this.taskService.findById(rowData.taskId).subscribe(
      res => {
        console.log('task-find SUCCESS: ' + JSON.stringify(res));
        let fullTaskObject = res.data.task;
        fullTaskObject[event.field] = rowData[event.field];
        this.formUpdate(fullTaskObject);
      });
  }
  onCellEditCancel(): void { this.messageService.add({ severity: 'info', summary: 'Update Canceled', detail: 'No changes were saved' }); }
  formUpdate(task: Task) {
    console.log('Task: Updating...' + JSON.stringify(task));
    this.taskService.update(task)
      .pipe(first())
      .subscribe(
        res => {
          console.log('Task-Update SUCCESS: ' + JSON.stringify(res));
          const message = typeof res === 'string' ? res : (res?.message || 'Task updated successfully');
          this.messageService.add({ severity: 'success', summary: 'Success', detail: message, life: 5000 });
        },
        err => {
          console.log('Task-Update FAIL: ' + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
          this.formLoading = false;
        });
  }
  removedFilter(removedChip: any) {
    console.log(removedChip);
    delete this.lazyLoadEvent.filters[removedChip.value?.name];
    switch (removedChip.value?.name) {
      case 'status':
        this.selectedStatusFilter = [];
        break;
      case 'priority':
        this.selectedPriorityFilter = [];
        this.selectedPriority = null;
        break;
      case 'name':
        this.selectedFilterName = '';
        break;
      case 'taskId':
        this.taskTagSelected = '';
        this.selectedFilterTagSearch = '';
        this.taskTag = null;
        break;
      case 'createdByUserVO.userId':
        this.createdBySearchToUser = null;
        break;
      case 'assignedToUserVO.userId':
        this.assignedSearchToUser = null;
        break;
      case 'requestedByUserVO.userId':
        this.requestedBySearchToUser = null;
        break;
      case 'tagList':
        this.taskTag = null;
        break;
      case 'loadstatus':
        this.loadStatusEnabled = false;
        break;
    }
    this.loadLazy(this.lazyLoadEvent);
  }

  exportSelected($event: any) {
    let taskDatList: any[] = [];
    this.taskList.forEach(entry => {
      let task = entry.data;
      let row: any = {};
      row.name = task.name;
      row.dateCreated = moment(task.dateCreated).toDate();
      row.dateToFollowup = moment(task.dateToFollowup).toDate();
      row.dateDue = moment(task.dateDue).toDate();
      row['assignedToUserVO.lastName'] = this.fullName(task.assignedTo);
      row['createdByUserVO.lastName'] = this.fullName(task.ownedBy);
      row.status = this.statuses[task.status]?.name;
      taskDatList.push(row);
    });

    this.importExportComponent.exporData($event, taskDatList, 'Tasks');
  }

  showQuickAddDialog() {
    this.visible = true;
  }

  applyGrouping() {
    this.groupedTasks.clear();
    this.groupKeys = [];
    this.showGrouping = this.groupBy && this.groupBy !== 'none';

    if (!this.showGrouping || !this.tasks || this.tasks.length === 0) {
      return;
    }

    // Flatten tasks including children - optimized
    const allTasks: Task[] = [];
    const taskCount = this.tasks.length;
    
    // Pre-allocate array size estimate for better performance
    let estimatedSize = taskCount;
    for (let i = 0; i < taskCount; i++) {
      const task = this.tasks[i];
      if (task) {
      allTasks.push(task);
      if (task.children && task.children.length > 0) {
        allTasks.push(...task.children);
      }
      }
    }

    // Group tasks - optimized with Map
    const groupedMap = new Map<string, Task[]>();
    
    for (let i = 0; i < allTasks.length; i++) {
      const task = allTasks[i];
      if (!task) continue;
      
      let groupKey = '';

      switch (this.groupBy) {
        case 'status':
          groupKey = `status_${(task as any).status || 0}`;
          break;
        case 'priority':
          groupKey = `priority_${(task as any).priority || 4}`;
          break;
        case 'assignee':
          groupKey = task.assignedTo?.userId ? `assignee_${task.assignedTo.userId}` : 'assignee_unassigned';
          break;
        case 'dueDate':
          if (task.dateDue) {
            const dueDate = new Date(task.dateDue);
            groupKey = `dueDate_${dueDate.toISOString().split('T')[0]}`;
          } else {
            groupKey = 'dueDate_no_date';
          }
          break;
        case 'createdDate':
          if ((task as any).dateCreated) {
            const createdDate = new Date((task as any).dateCreated);
            groupKey = `createdDate_${createdDate.toISOString().split('T')[0]}`;
          } else {
            groupKey = 'createdDate_no_date';
          }
          break;
        case 'completedDate':
          if ((task as any).dateCompleted) {
            const completedDate = new Date((task as any).dateCompleted);
            groupKey = `completedDate_${completedDate.toISOString().split('T')[0]}`;
          } else {
            groupKey = 'completedDate_no_date';
          }
          break;
        default:
          continue; // Use continue instead of return
      }

      if (!groupedMap.has(groupKey)) {
        groupedMap.set(groupKey, []);
        this.groupKeys.push(groupKey);
      }
      groupedMap.get(groupKey)!.push(task);
    }
    
    // Copy grouped data to this.groupedTasks
    groupedMap.forEach((tasks, key) => {
      this.groupedTasks.set(key, tasks);
    });
  }

  getGroupLabel(groupKey: string): string {
    if (groupKey.startsWith('status_')) {
      const status = parseInt(groupKey.split('_')[1]);
      const statusObj = this.statuses.find(s => s.value === status);
      return statusObj ? statusObj.name : `Status ${status}`;
    } else if (groupKey.startsWith('priority_')) {
      const priority = parseInt(groupKey.split('_')[1]);
      const priorityObj = this.priorities.find(p => p.value === priority);
      return priorityObj ? priorityObj.name : `Priority ${priority}`;
    } else if (groupKey.startsWith('assignee_')) {
      const userId = groupKey.split('_')[1];
      if (userId === 'unassigned') return 'Unassigned';
      // Find user
      const user = this.usersSearch?.find(u => u.userId === parseInt(userId));
      return user ? this.fullName(user) : 'Assignee';
    } else if (groupKey.startsWith('dueDate_')) {
      const dateStr = groupKey.split('_')[1];
      if (dateStr === 'no_date') return 'No Due Date';
      return `Due: ${new Date(dateStr).toLocaleDateString()}`;
    } else if (groupKey.startsWith('createdDate_')) {
      const dateStr = groupKey.split('_')[1];
      if (dateStr === 'no_date') return 'No Created Date';
      return `Created: ${new Date(dateStr).toLocaleDateString()}`;
    } else if (groupKey.startsWith('completedDate_')) {
      const dateStr = groupKey.split('_')[1];
      if (dateStr === 'no_date') return 'No Completed Date';
      return `Completed: ${new Date(dateStr).toLocaleDateString()}`;
    }
    return groupKey;
  }

  getTasksForGroup(groupKey: string): Task[] {
    return this.groupedTasks.get(groupKey) || [];
  }

  getDisplayColumns(): any[] {
    // Use merged columns if available, otherwise use defaults
    const colsToUse = (this.columns && this.columns.length > 0) ? this.columns : this.defaultColumns;
    return colsToUse.filter(col => col.visible !== false && col.visible !== undefined);
  }

  isColumnVisible(field: string): boolean {
    // Always show ID column
    if (field === 'taskId') {
      return true;
    }
    const displayCols = this.getDisplayColumns();
    const isVisible = displayCols.some(col => col.field === field);
    // Debug: log when column visibility is checked
    // console.log(`Checking visibility for ${field}:`, isVisible, 'Available columns:', displayCols.map(c => `${c.field}:${c.visible}`));
    return isVisible;
  }

  getColumnIndex(field: string): number {
    const displayCols = this.getDisplayColumns();
    return displayCols.findIndex(col => col.field === field);
  }

  // Transform taskList to include grouping when enabled
  getGroupedTaskList(): any[] {
    if (!this.showGrouping || this.groupKeys.length === 0) {
      return this.taskList;
    }

    const groupedList: any[] = [];
    this.groupKeys.forEach(groupKey => {
      // Add group header
      const groupLabel = this.getGroupLabel(groupKey);
      const groupTasks = this.getTasksForGroup(groupKey);
      
      // Find corresponding taskList nodes for these tasks
      groupTasks.forEach(task => {
        const taskNode = this.taskList.find(node => node.data?.taskId === task.taskId);
        if (taskNode) {
          groupedList.push(taskNode);
        }
      });
    });

    return groupedList.length > 0 ? groupedList : this.taskList;
  }

  /**
   * Process tasks asynchronously in chunks to prevent UI blocking
   */
  private processTasksAsync(tasks: Task[]): void {
    this.taskList = [];
    this.updateTableData();
    const BATCH_SIZE = 100; // Process 100 tasks at a time (increased for better performance)
    let currentIndex = 0;
    const tempTaskList: any[] = []; // Build list in memory first

    const processBatch = () => {
      const startTime = performance.now();
      const endIndex = Math.min(currentIndex + BATCH_SIZE, tasks.length);
      
      // Process batch
      for (let i = currentIndex; i < endIndex; i++) {
        let curTak = tasks[i];
        if (!curTak) continue; // Skip null/undefined tasks
        
        // Ensure children array exists before filtering
        if (!curTak.children) {
          curTak.children = [];
        }
        
        if (this.selectedStatusFilter && this.selectedStatusFilter.length > 0 && curTak.children) {
          curTak.children = curTak.children.filter(e => e && this.selectedStatusFilter.includes(e.status));
        }
        // un comment below if we need to have filter on sub tasks for users like createdby and assignto and requestedby
        /*if ( this.lazyLoadEvent.filters['assignedToUserVO.userId'] ){
          curTak.children = curTak.children.filter(e => this.lazyLoadEvent.filters['assignedToUserVO.userId']?.value == e.assignedTo?.userId);
        }
        if ( this.lazyLoadEvent.filters['createdByUserVO.userId'] ){
          curTak.children = curTak.children.filter(e => this.createdBySearchToUser?.userId == e.createdBy?.userId);
        }
        if ( this.lazyLoadEvent.filters['requestedByUserVO.userId'] ){
          curTak.children = curTak.children.filter(e => this.requestedBySearchToUser?.userId == e.requestedBy?.userId);
        }*/

        let node = {
          'data': curTak,
          leaf: false
        };
        tempTaskList.push(node);
      }
      
      currentIndex = endIndex;
      const elapsed = performance.now() - startTime;
      
      // Update taskList reference - but only trigger change detection every few batches
      this.taskList = [...tempTaskList];
      this.updateTableData();
      
      if (currentIndex < tasks.length) {
        // Process next batch - yield to browser to keep UI responsive
        // Use requestAnimationFrame for smoother processing
        requestAnimationFrame(() => {
          processBatch();
        });
      } else {
        // All tasks processed - final update
        this.taskList = [...tempTaskList];
        this.updateTableData();
        
        // Emit tasks for calendar view
        this.tasksLoaded.emit(this.tasks);
        
        // Apply grouping if enabled (after tasks are loaded) - use setTimeout to prevent blocking
        setTimeout(() => {
          try {
            this.applyGrouping();
            // Only call detectChanges once after grouping is done
            this.cdr.markForCheck(); // Use markForCheck instead of detectChanges for better performance
          } catch (groupError) {
            console.error('Error in applyGrouping:', groupError);
          }
        }, 0);
      }
    };
    
    // Start processing
    if (tasks.length > 0) {
      // Use setTimeout to ensure UI is updated first
      setTimeout(() => {
        processBatch();
      }, 0);
    } else {
      // No tasks, just emit and apply grouping
      this.taskList = [];
      this.updateTableData();
      this.tasksLoaded.emit(this.tasks);
      setTimeout(() => {
        try {
          this.applyGrouping();
          this.cdr.detectChanges();
        } catch (groupError) {
          console.error('Error in applyGrouping:', groupError);
        }
      }, 0);
    }
  }

  ngOnDestroy(): void {
    // Set flag to prevent new requests
    this.isDestroying = true;
    
    // Cancel any pending subscriptions
    this.destroy$.next();
    this.destroy$.complete();
    
    if (this.currentLoadSubscription) {
      this.currentLoadSubscription.unsubscribe();
      this.currentLoadSubscription = null;
    }
    
    // Reset loading state
    this.loading = false;
    
    // Clean up other subscriptions
    if (this.currentUserSubscription) {
      this.currentUserSubscription.unsubscribe();
    }
    if (this.taskSummarySubscription) {
      this.taskSummarySubscription.unsubscribe();
    }
  }

}